<template>
  <div class="query">
    <!--    输入框-->
    <section class="input-verification">
      <input v-model="verificationValue" placeholder="请输入验证码" />
    </section>
    <!--    扫码-->
    <section class="scan-code sweep">
      <input type="file" @change="upload($event)" />
      <div>
        <img src="../assets/images/scan-code.png" />
        <p>扫码输入</p>
      </div>
    </section>
    <!--    验证查询-->
    <section class="verify-query">
      <button @click="verifyQueryBtn">验证查询</button>
    </section>
  </div>
</template>

<script>
import jsQR from "jsqr";
import Jimp from "jimp";
import { Toast } from "vant";

export default {
  name: "Query",
  data() {
    return {
      //用户输入的id
      verificationValue: "",
    };
  },
  methods: {
    upload(e) {
      const file = e.target.files[0];
      const createObjectURL =
        window.createObjectURL ||
        window.URL.createObjectURL ||
        window.webkitURL.createObjectUR;
      this.result = "";
      this.imgurl = createObjectURL(file);

      const fReader = new FileReader();
      fReader.readAsDataURL(file); // Base64 8Bit字节码
      // fReader.readAsBinaryString(file);  // Binary 原始二进制
      // fReader.readAsArrayBuffer(file);   // ArrayBuffer 文件流
      fReader.onload = (e) => {
        this.imgurl2 = e.target.result;
        e.target.result &&
          Jimp.read(e.target.result)
            .then(async (res) => {
              const { data, width, height } = res.bitmap;
              try {
                const resolve = await jsQR(data, width, height);
                console.log(resolve);
                let indexOfUrl = resolve.data.indexOf("?");
                this.result = resolve.data.slice(indexOfUrl);
                console.log(this.result);
                   let urlParms = this.GetRequest(this.result);
                   console.log(urlParms);
                  //  存储扫码的id
                  // 存储扫码的批次号
                   this.verificationValue = urlParms.id;
                   this.batch_Code = urlParms.batch_code;
                // let getItemValInit = JSON.stringify(res.data);
                // localStorage.setItem("getItemVal1", getItemValInit);
              } catch (err) {
                // this.verificationValue = "识别失败，请检查二维码是否正确！";

                console.error("识别失败，请检查二维码是否正确！", err);
              } finally {
                console.info("读取到的文件：", res);
              }
            })
            .catch((err) => {
              console.error("文件读取错误：", err);
            });
      };
    },

    async verifyQueryBtn() {
      // 本地的id
      // const batch_Code = localStorage.getItem("batch_Code");
      if(this.verificationValue.trim()==""){
            return Toast("请输入验证码");
      }
      // console.log("验证查询");
      // this.id = localStorage.getItem("id");
         const toast = Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: "正在查询",
        });
      const { data: res } = await this.$api.getQuery(this.verificationValue);
      if (res.code === 200) {
     
        let second = 1;
        const timer = setInterval(() => {
          second--;
          if (second) {
            toast.message = `亲，正在查询`;
          } else {
            clearInterval(timer);
          this.$router.push(`/result?id=${this.verificationValue}`);
            // 手动清除 Toast
            Toast.clear();
          }
        }, 1000);
      } else {
        Toast(res.msg);
        return;
      }

      console.log(res);
    },
  },
};
</script>

<style scoped lang="scss">
.query {
  width: 100%;
  height: 108px;
  background: #56b5a1;
  z-index: 999999;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;

  .sweep {
    position: relative;
    input {
      width: 100%;
      height: 100%;
      position: absolute;
      opacity: 0;
    }
  }

  .input-verification {
    width: 394px;
    height: 76px;
    background: #26907a;
    border-radius: 8px;
    input {
      width: 100%;
      height: 100%;
      background: #26907a;
      border-radius: 8px;
      color: #fff;
      border: 0;
      outline: none;
      padding-left: 20px;
      font-size: 28px;
      &::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #fff;
        font-size: 28px;
      }

      &::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #fff;
        font-size: 28px;
      }

      &:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #fff;
        font-size: 28px;
      }
    }
  }
  .scan-code {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: 20px;
    div {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }
    img {
      width: 60px;
    }
    p {
      font-size: 20px;
      font-weight: 400;
      color: #ffffff;
      margin: 4px 0 0 0;
    }
  }
  .verify-query {
    width: 180px;
    height: 76px;
    background: #eafe67;
    border-radius: 8px;
    button {
      border: 0;
      outline: none;
      width: 100%;
      height: 100%;
      background: #eafe67;
      border-radius: 8px;
    }
  }
}
</style>